import { useDateLocale } from "../../i18n/use-date-locale";
import { useState } from "react";
import { format } from "date-fns";
import { CalendarIcon } from "lucide-react";
import { Button } from "../ui/button";
import { Calendar } from "../ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { cn } from "../../lib/utils";

type WeekPickerProps = {
  selectedDate: Date; week: Date[]; onSelect: (date: Date) => void;
  id?: string; warning?: boolean; className?: string;
};

export function WeekPicker({ selectedDate, week, onSelect, id = "schedule-week", warning = false, className }: WeekPickerProps) {
  const locale = useDateLocale();
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button id={id} variant="outline" className={cn("h-9 min-w-0 flex-1 justify-start border-neutral-300 font-mono text-xs font-normal", warning && "border-amber-500 bg-amber-50 text-amber-900 hover:bg-amber-100", className)}>
          <CalendarIcon className="size-3.5" />
          <span className="min-w-0 truncate" title={`${format(week[0]!, "yyyy-MM-dd")} – ${format(week[6]!, "yyyy-MM-dd")}`}>
            {format(week[0]!, "yyyy-MM-dd")} – {format(week[6]!, "yyyy-MM-dd")}
          </span>
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-auto border-neutral-200 p-0 font-['Inter',sans-serif]">
        <Calendar
          mode="range"
          locale={locale}
          weekStartsOn={1}
          defaultMonth={selectedDate}
          selected={{ from: week[0]!, to: week[6]! }}
          onDayClick={date => { onSelect(date); setOpen(false); }}
          autoFocus
        />
      </PopoverContent>
    </Popover>
  );
}
